export enum GameDisallowedReason {
  District = 'District',
  Parent = 'Parent',
  ParentOptIn = 'ParentOptIn',
  Grade = 'Grade',
  Homework = 'Homework',
  PlayTime = 'PlayTime'
}
